import { Button, Dropdown, Input, Modal, Row, Text } from 'components';
import { nations, theme } from 'lib';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  background-color: #e5e5e5;
`;

const ContentArea = styled.div`
  width: 480px;
  margin-top: 78px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .contentText {
    margin-top: 38px;

    @media (max-width: 1024px) {
      margin-top: 42px;
      width: 285px;
    }
  }

  .headerText {
    font-family: CeraPro;
    font-size: 20px;
    font-weight: 700;
    line-height: 24px;
    color: ${theme.SECONDARY};
    width: 100%;
    margin: 30px 0 15px;

    @media (max-width: 1024px) {
      font-size: 18px;
      margin: 15px 0 11px;
    }
  }

  button {
    margin: 30px 0 91px;

    @media (max-width: 1024px) {
      width: 286px !important;
      height: 39px !important;
      margin-top: 46px;

      p {
        font-size: 18px;
      }
    }
  }

  @media (max-width: 1024px) {
    margin-top: 54px;
    width: 290px;
  }
`;

const YourDetails = styled.div`
  margin-top: 5px;
  width: 480px;

  @media (max-width: 1024px) {
    margin-top: 39px;

    .headerText {
      margin-left: 3px;
    }
  }
`;

const CompanyInformation = styled.div`
  .headerText {
    margin-bottom: 13px;
  }

  @media (max-width: 1024px) {
    margin-top: 8px;

    .headerText {
      margin-left: 3px;
      margin-bottom: 10px;
    }
  }
`;

const StyledDropdown = styled(Dropdown)`
  @media (max-width: 1024px) {
    height: 39px;
    width: 286px;

    p {
      font-size: 18px;
    }
  }
`;

const HeaderText = styled.p`
  font-family: CeraPro;
  font-size: 20px;
  font-weight: 700;
  line-height: 24px;
  color: ${theme.SECONDARY};

  @media (max-width: 1024px) {
    font-size: 18px;
  }
`;

const CustomInput = styled(Input)`
  margin-bottom: 13px;
  width: 410px;

  @media (max-width: 1024px) {
    height: 39px;
    width: 246px;
    font-size: 18px;
    margin-bottom: 10px;
  }
`;

const LetsTalkModal = ({ visible, closeModal }) => {
  const { t } = useTranslation();
  const [firstName, setFirstName] = useState(''),
    [lastName, setLastName] = useState(''),
    [email, setEmail] = useState(''),
    [companyName, setCompanyName] = useState(''),
    [companyWebsite, setCompanyWebsite] = useState(''),
    [country, setCountry] = useState(null),
    [phone, setPhone] = useState('');

  function submit() {
    console.log({ firstName, lastName, email, companyName, companyWebsite, country, phone });
  }

  return (
    <React.Fragment>
      <Modal visible={visible} closeModal={closeModal} website>
        <Wrapper>
          <ContentArea>
            <HeaderText>{t('website.becomeASponsor')}</HeaderText>
            <Row wid="100%">
              <Text className="contentText" size="20px" lineHt="26px">
                {t('website.letsWorkTogether')}
              </Text>
            </Row>

            <YourDetails>
              <div className="headerText">{t('website.yourDetails')}</div>

              <CustomInput
                value={firstName}
                onChange={({ target }) => setFirstName(target.value)}
                form
                website
                placeholder={t('website.firstName')}
              />

              <CustomInput
                value={lastName}
                onChange={({ target }) => setLastName(target.value)}
                form
                website
                placeholder={t('website.lastName')}
              />

              <CustomInput
                value={email}
                onChange={({ target }) => setEmail(target.value)}
                form
                website
                placeholder={t('website.emailAddress')}
              />
            </YourDetails>

            <CompanyInformation>
              <div className="headerText">{t('website.companyInformation')}</div>

              <CustomInput
                value={companyName}
                onChange={({ target }) => setCompanyName(target.value)}
                form
                website
                placeholder={t('website.companyName')}
              />

              <CustomInput
                value={companyWebsite}
                onChange={({ target }) => setCompanyWebsite(target.value)}
                form
                website
                placeholder={t('website.companyWebsite')}
              />

              <StyledDropdown
                title="Country"
                marg="0 0 13px"
                options={nations}
                selected={country}
                handleSelect={(e) => setCountry(e.value)}
                website
              />

              <CustomInput
                value={phone}
                onChange={({ target }) => setPhone(target.value)}
                form
                website
                placeholder={t('website.phoneNumber')}
              />
            </CompanyInformation>

            <Button website text={t('website.submit')} onClick={submit} />
          </ContentArea>
        </Wrapper>
      </Modal>
    </React.Fragment>
  );
};

export default LetsTalkModal;
